'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.factory('baseModal', function ($rootScope, $ionicModal, $ionicTemplateLoader, $timeout) {

    /**
     * default props
     */
    var props = {

      /**
       * 内容覆盖整个视窗 默认为true
       */
      slideDirection: {
        type: String,
        default: 'up'
      },
      /**
       * 内容覆盖整个视窗 默认为true
       */
      fullScreen: {
        type: Boolean,
        default: true
      },
      /**
       * modal视图样式名
       */
      modalViewClassName: {
        type: String,
        default: ''
      },
      /**
       * modal视图样式 配合fullScreen使用 默认为空 即不做设置
       */
      modalViewStyle: {
        type: Object,
        default: null
      }
    };

    /**
     * 创建 options
     */
    function createOptions(options) {
      var _this = this,
          _options = {};

      (0, _forEach2.default)(props, function (value, key) {
        _options[key] = value.default;
      });

      // options setter
      _this.setOptions = function (options) {
        if ((0, _objectType.isObject)(options)) {
          (0, _forEach2.default)(options, function (value, key) {
            if (props.hasOwnProperty(key)) {
              if (!(0, _objectType.isNullOrUndefined)(value)) {
                if (value.constructor === props[key].type) {
                  _options[key] = value;
                } else {
                  throw 'Invalid prop: type check failed for prop "' + key + '". Expected ' + props[key].type.name + ', got ' + value.constructor.name + '.';
                }
              }
            }
          });
        }
        return _options;
      };

      return _this.setOptions(options);
    }

    /**
     * 创建 scope
     */
    function createScope(scope, options) {
      scope = scope && scope.$new() || $rootScope.$new(true);

      if (!options.fullScreen) {
        options.modalViewStyle = options.modalViewStyle || {};
        if (options.slideDirection === 'up') {
          (0, _extend2.default)(options.modalViewStyle, {
            bottom: 0, top: 'auto', 'min-height': 'initial', height: '320px'
          });
        } else if (options.slideDirection === 'left') {
          (0, _extend2.default)(options.modalViewStyle, {
            right: 0, width: '86%'
          });
        }
      }

      // 背景颜色灰色透明 默认为false 当fullScreen为false时 值为true
      options.backdropTransparentGray = !options.fullScreen;

      (0, _extend2.default)(scope, {
        modalViewStyle: options.modalViewStyle,
        modalViewClassName: options.modalViewClassName,
        backdropTransparentGray: options.backdropTransparentGray
      });

      return scope;
    }

    /**
     * 创建$ionicModal实例
     */
    function createModal(scope, options, templateString) {
      var templateBase = require('./baseModal.html');
      if (templateString) {
        templateString = templateBase.replace(new RegExp('templatePlaceholder', 'gm'), templateString);
      } else {
        templateString = templateBase.replace(new RegExp('templatePlaceholder', 'gm'), '');
      }
      return $ionicModal.fromTemplate(templateString, {
        scope: scope,
        animation: 'slide-in-' + options.slideDirection,
        backdropClickToClose: options.backdropClickToClose
      });
    }

    function BaseModal(scope, options, templateString) {

      var self = this;

      var _options = createOptions.call(self, options);

      var _scope = createScope(scope, _options);

      var _modal = createModal(_scope, _options, templateString);

      /**
       * 显示 modal
       */
      self.show = function () {
        if (_options.backdropTransparentGray) {
          $timeout(function () {
            _modal.el.querySelector('.modal-backdrop-bg').classList.add('base-modal-bg-gray');
          });
        }
        return _modal.show().then(function () {
          _scope.$evalAsync(function () {
            _modal.$el.on('click', function (e) {
              if (e.target === _modal.el) {
                self.hide();
              }
            });
          });
        });
      };

      /**
       * 隐藏 modal
       */
      self.hide = function () {
        if (_options.backdropTransparentGray) {
          _modal.el.querySelector('.modal-backdrop-bg').classList.remove('base-modal-bg-gray');
        }
        return _modal.hide();
      };

      /**
       * 从dom中删除 modal
       */
      self.remove = function () {
        return _modal.remove();
      };

      return self;
    }

    return {
      fromTemplate: function fromTemplate(scope, options, templateString) {
        return new BaseModal(scope, options, templateString);
      },
      fromTemplateUrl: function fromTemplateUrl(scope, options, templateUrl) {
        return $ionicTemplateLoader.load(templateUrl).then(function (templateString) {
          return new BaseModal(scope, options, templateString);
        }, function () {
          throw new Error('Could not find the specified template: ' + templateUrl);
        });
      }
    };
  });
  return app;
};

require('angular');

require('ionic');

require('./baseModal.scss');

var _forEach = require('../../../utils/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _objectType = require('../../../utils/objectType');

var _extend = require('../../../utils/extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

; /**
   * ionic modal base
   *
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/baseModal/index.js
// module id = 158
// module chunks = 0